export default __webpack_public_path__ + "static/media/android_qr.71e8d2c6.png";